<template>
  <div id="cardGrid" class="row row-cols-1 row-cols-md-3 row-cols-lg-4">
    <PrimaryCard />

    <div class="card secondary" v-for="(office, index) in getOfficesNearby" :key="index">
      <div class="card-header">
        <div class="row">
          <div class="col-2">

            <i v-if="office.OfficeTypes[0].Type === 'kiosk'" class="card__icon dock_icon"></i>

            <i v-if="office.OfficeTypes[0].Type === 'license'" class="card__icon icon-card"></i>
            <i v-if="office.OfficeTypes[0].Type === 'plate'" class="card__icon icon-directions-car"></i>
            <i v-if="
                  office.OfficeTypes[0].Type !== 'kiosk' &&
                  office.OfficeTypes[0].Type !== 'license' &&
                  office.OfficeTypes[0].Type !== 'plate'
                " class="card__icon icon-government-building"></i>
          </div>

          <div class="col-10">
            <h5>{{ office.Name }}</h5>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div v-for="(offtype, index) in office.OfficeTypes" :key="index">
          <span v-if="offtype.Type === 'kiosk'"><i class="icon-services-list"></i> Kiosk NCDMV Services</span>

          <span v-if="offtype.Type === 'license'"><i class="icon-services-list"></i> Driver License</span>
          <span v-if="offtype.Type === 'plate'"><i class="icon-services-list"></i> Plate &amp; Vehicle
            Registration</span>
          <span v-if="offtype.Type === 'irp'"><i class="icon-services-list"></i> Commercial Trucking (IRP)</span>
          <span v-if="offtype.Type === 'lt'"><i class="icon-services-list"></i> License &amp; Theft Bureau</span>
          <span v-if="offtype.Type === 'irp,plate'"><i class="icon-services-list"></i> Commercial Trucking (IRP)<br /><i
              class="icon-services-list"></i>
            Plate &amp; Vehicle Registration</span><br />
        </div>

        <br />
        <p>
          <template v-if="office.Addresses[0].City !== 'undefined'">
            Located in {{ office.Addresses[0].City }}.
          </template>


          <template
            v-if="office.Status.Title.length > 0 && this.rootStore.isStateHoliday === true && office.OfficeTypes[0].Type !== 'kiosk'">
            This office is currently closed for the holiday.
          </template>
          <template v-if="office.Status.Title.length > 0  && this.rootStore.isStateHoliday === false">
            This office is currently <em>{{ office.Status.Title }}</em>.
          </template>

        </p>
       <!-- <p v-if="office.Status.Title !== 'Closed' && office.IWTavgWT !== null && office.IWTavgWT !== undefined">
          Current wait <strong>{{ office.IWTavgWT }}</strong>
        </p> -->
    
        <div v-if="office.Notes">
          <div class="alert alert-warning" color="warning">
            <div class="alert">
              <em class="hover-scroll">{{ office.Notes }}</em>
            </div>
          </div>
        </div>
       <div v-if="showIWTMessage(office)">
          <WaitTimeCard :waitTime="office.IWTavgWT" :capacity="office.IWTcapacity" :lastUpdated="office.IWTlastUpdated"
            :error="office.IWTError" :errorMessage="office.IWTErrorMessage" />
        </div>
      
      </div>

      <div class="card-footer">
        <img class="secondarymap" v-on:click="zoomBigMapToOffice(office.Lat, office.Long)"
          :src="makeMapImageSecondary(office.Lat, office.Long)" :alt="`Map showing location of ${office.Name}`" />

        <span class="btn btn-outline-primary" v-on:click="zoomBigMapToOffice(office.Lat, office.Long)">Show on Map
        </span>
      </div>
    </div>

  </div>
</template>



<script>
/*eslint no-redeclare: */
import { useRootStore } from "../store";
import PrimaryCard from "./PrimaryCard.vue";
import { ref } from 'vue';
import { fetchWaitTimeAndCapacity } from "../actions/waitTimeActions";
import WaitTimeCard from "./waitTimeCard.vue";
export default {
  components: {
    PrimaryCard,
    WaitTimeCard
  },
  data() {
    return {
      rootStore: useRootStore(),
      mapImage: "",
      dataUserLocation: "",
      showTooltip: ref(false),
      showIndex: ref(null)
    };
  },
  methods: {
    pollForWaitTime(retries = 15, delay = 500) {
      if (
        this.getOfficesNearby && Array.isArray(this.getOfficesNearby) && this.getOfficesNearby.length > 0 &&
        this.getOfficeDL && Array.isArray(this.getOfficeDL) && this.getOfficeDL.length > 0
      ) {
        this.addIWTtoSecondaryCards();
      } else if (retries > 0) {
        setTimeout(() => {
          console.log("coming here-after-officeornearbydata-delay", retries)
          this.pollForWaitTime(retries-1, delay);
        }, delay);
      } else {
        console.warn('Polling for WaitTime timed out. Data sources not ready.');
      }
    },
     showIWTMessage(office) {
      // Only show IWT message for license offices (not plate, kiosk, irp, lt), when feature is enabled, office is open, and iwtLoadWindow is true
      if (
        this.rootStore.allowedDateTime?.enableWaitTimesFeature &&
        this.getIsStateHoliday === false 
        && this.getIWTLoadWindow === true && office.OfficeTypes[0].Type === "license" && office.Status.Title !== "Closed"
      ) {
        return true;
      }
      return false;

    },
    zoomBigMapToOffice(plat, plong) {
      var _zoomCoords = {};

      _zoomCoords.Lat = plat;
      _zoomCoords.Long = plong;

      document
        .getElementById("dmvLocsDashboard")
        .scrollIntoView({ behavior: "smooth", block: "center" });

      // clear any primary selected result
      this.rootStore.SET_PRIMARY_CARD("");

      this.rootStore.SET_ZOOMED_LOCATION(_zoomCoords);
    },

    makeMapImageSecondary(lat, long) {
      // console.log('Generating an image for secondary cards')
      var baseUrl = "https://dev.virtualearth.net/REST/V1/Imagery/Map/Road/";
      var Lat = lat;
      var Long = long;
      var bingKey = this.getMapAPIkey;

      return (
        baseUrl +
        Lat +
        "%2C" +
        Long +
        "/10?mapSize=250,75&format=png&pushpin=" +
        Lat +
        "%2C" +
        Long +
        ";66;&key=" +
        bingKey
      );
    },

    async loadNearByOffices (searchType, clearOffices, passedForm) {
      // Determine if we clear out existing secondary locations or not
      if (clearOffices === true) {
        this.rootStore.CLEAR_NEARBY_OFFICES([]);
      }

      // console.log('START ------------------------------------')
      // console.log('loadNearbyOffices function has fired')
      // console.log('This is a ' + searchType + ' search')
      // console.log('Clearing existing results out first? ' + clearOffices)
      // console.log('Search is ' + JSON.stringify(passedForm))
      // console.log('END ------------------------------------')

      var thisLoaded = this;
      try {
        await fetch(thisLoaded.getLocationsURLsearch, {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Accept: "application/json, text/javascript, */*; q=0.01",
          },
          body: JSON.stringify(passedForm),
        }).then((response) => {
          if (!response.ok) {
            return Promise.reject(`Response status: ${response.status}`)
          }
          return response.json()
        }).then((data) => {

          // Returned results
          var _locationResults = JSON.parse(data);

          // Add to object we'll send to store
          var _locationBag = [];

          // If no empty results
          if (_locationResults.length > 0) {
            // Move anything existing to the bag
            if (thisLoaded.getOfficesNearby.length > 0) {
              thisLoaded.getOfficesNearby.forEach(function (_location) {
                _locationBag.push(_location);
              });
            }

            // move anything that isn't the Primary card to the bag
            _locationResults.forEach(function (_location) {
              if (_location.Name !== thisLoaded.getPrimaryCard.name) {
                _locationBag.push(_location);
              }
            });
          } // if

          // Add any existing ones to location bag
          if (thisLoaded.getOfficesNearby.length > 0) {
            thisLoaded.getOfficesNearby.forEach(function (_existingoff) {
              _locationBag.push(_existingoff);
            });
          }

          // remove duplicates
          var _filteredBag = Array.from(
            new Set(_locationBag.map((a) => a.ID))
          ).map((ID) => {
            return _locationBag.find((a) => a.ID === ID);
          });

          // Pass to store
          thisLoaded.rootStore.SET_NEARBY_OFFICES(_filteredBag);
        }).then(() => {
          if (searchType === "fromPrimaryCardCity") {
            // handled by watcher
          } else if (searchType === "fromPrimaryCardCounty") {
            // handled by watcher
          }

          if (searchType === "fromUserLocation") {
            // If the search was by location, now perform another based on city
            if (thisLoaded.getMapAPIresponse && typeof thisLoaded.getMapAPIresponse.City !== "undefined") {
              thisLoaded.loadNearByOffices("fromUserLocationCity", false, {
                autoIncrement: true,
                distance: 1,
                lat: "",
                lon: "",
                officeType: "license,plate,lt,irp,kiosk",
                searchField: "city",
                searchTerm: thisLoaded.getMapAPIresponse.City,
              });
            }
          } else if (searchType === "fromUserLocationCity") {
            if (typeof thisLoaded.getMapAPIresponse.City !== "undefined") {
              thisLoaded.loadNearByOffices("fromUserLocationCounty", false, {
                autoIncrement: true,
                distance: 1,
                lat: "",
                lon: "",
                officeType: "license,plate,lt,irp,kiosk",
                searchField: "county",
                searchTerm: thisLoaded.getMapAPIresponse.County,
              });
            }
          }
          thisLoaded.pollForWaitTime(15, 500);
        })
      } catch (error) {
        // this.errorModal = true;
        console.log(`Error loading NCDMV Office Locations from service ${thisLoaded.getLocationsURLsearch} and failed with ${error}`);
      }
        // .catch(function (error) {
        //   console.log(error);
        // });
    },

    // Grabs current wait time from store. Expects ID of DMV office and location type

    // Just does DL and LPA offices for now.
    getNearbyOfficeTimes(ID,type){
      // console.log(ID, type )
     
      var thisLoaded = this
      if(type === "license"){  
        const matchDLOffice = thisLoaded.getOfficeDL.filter(i => ID === i.id);
        // console.log("License office")

        if(matchDLOffice[0] !== undefined && matchDLOffice[0]["IWTavgWT"] !== undefined){
          // console.log(matchDLOffice[0]["IWTavgWT"])
          return matchDLOffice[0]["IWTavgWT"]
        }        
      } else if(type === "plate"){
       const matchLPAOffice = thisLoaded.getOfficeLPA.filter(i => ID === i.id);
        // console.log("License office")
        // console.log(matchLPAOffice)

        if(matchLPAOffice[0] !== undefined && matchLPAOffice[0]["IWTavgWT"] !== undefined){
          // console.log(matchLPAOffice[0]["IWTavgWT"])
          return matchLPAOffice[0]["IWTavgWT"]
        }   
      } 

      
    },

 

    async addIWTtoSecondaryCards() {
      // Loops through loaded secondary office locations and adds IWT values.
      var thisLoaded = this;
      if (this.getOfficesNearby !== undefined && this.getOfficesNearby.length > 0) {
        // Create a new array of office objects with updated IWTavgWT
        const nearbyOfficesToAddIWT = await Promise.all(
          thisLoaded.getOfficesNearby.map(async (_off) => {
            // Create a deep clone to ensure reactivity for nested properties
            const officeCopy = JSON.parse(JSON.stringify(_off));
            const latestOffice = thisLoaded.getOfficeDL?.find(o => o?.id === _off?.ID);
            if (latestOffice?.IWTOffice && thisLoaded.getIsStateHoliday === false 
              && thisLoaded.getIWTLoadWindow === true) {
              try {
                const IWTWaitTime = await fetchWaitTimeAndCapacity(latestOffice?.IWTOffice);
                officeCopy.IWTavgWT = IWTWaitTime.waitTime;
                officeCopy.IWTcapacity = IWTWaitTime.capacity;
                officeCopy.IWTlastUpdated = IWTWaitTime.lastUpdated;
                officeCopy.IWTError = IWTWaitTime.error;
                officeCopy.IWTErrorMessage = IWTWaitTime.errorMessage;
              } catch (e) {
                officeCopy.IWTavgWT = null;
                officeCopy.IWTError = true;
                officeCopy.IWTErrorMessage = e?.message || 'Wait times are not available right now.';
              }
            } else {
              officeCopy.IWTavgWT = null;
              officeCopy.IWTcapacity = null;
              officeCopy.IWTlastUpdated = null;
              officeCopy.IWTError = false;
              officeCopy.IWTErrorMessage = '';
            }
            return officeCopy;
          })
        );
        // Update store with IWT-enriched locations
        this.rootStore.SET_NEARBY_OFFICES(nearbyOfficesToAddIWT);
      }
    }
  },
  watch: {

    getPrimaryCard: function () {
      // After primary card piced, load nearby city, and by type
      if (this.getPrimaryCard.length !== 0) {
        this.loadNearByOffices("fromPrimaryCardCity", true, {
          autoIncrement: true,
          distance: 1,
          lat: "",
          lon: "",
          officeType: "",
          searchField: "city",
          searchTerm: this.getPrimaryCard.city,
        });
      }

      // After primary card piced, load nearby county, and by type
      if (this.getPrimaryCard.length !== 0) {
        this.loadNearByOffices("fromPrimaryCardCounty", false, {
          autoIncrement: true,
          distance: 1,
          lat: "",
          lon: "",
          officeType: this.getPrimaryCard.officeTypes,
          searchField: "county",
          searchTerm: this.getPrimaryCard.counties,
        });
      }
    },

    dataUserLocation: function () {
      // A County specific search is different. It just does that one search
      if (
        typeof this.dataUserLocation === "object" &&
        this.dataUserLocation?.County !== undefined
      ) {
        this.loadNearByOffices("fromPrimaryCardCounty", true, {
          autoIncrement: true,
          distance: 1,
          lat: "",
          lon: "",
          officeType: "license,plate,lt,irp,kiosk",
          searchField: "county",
          taco: true,
          searchTerm: this.dataUserLocation?.County,
        });
      }

      // All other searches follow the lat/long to city to county line
      if (
        typeof this.dataUserLocation === "object" &&
        !this.dataUserLocation?.County
      ) {
        const pollForLatLong = (retries = 15, delay = 500) => {
          const lat = this.dataUserLocation?.Lat;
          const lon = this.dataUserLocation?.Long;
          if (lat !== undefined && lon !== undefined) {
            console.log("Not a county search - Lat/Long found");
            this.loadNearByOffices("fromUserLocation", true, {
              autoIncrement: true,
              distance: 1,
              lat: lat,
              lon: lon,
              officeType: "license,plate,lt,irp,kiosk", // must have all types in here
              // searchField:"",
              searchTerm: lat + "," + lon,
            });
          } else if (retries > 0) {
            console.log("Polling for Lat/Long in dataUserLocation...");
            setTimeout(() => pollForLatLong(retries - 1, delay), delay);
          } else {
            console.warn("Polling for Lat/Long timed out. dataUserLocation:", this.dataUserLocation);
          }
        };
        pollForLatLong();
      }
    },

    getUserLocation: function () {
      // Update local data with vuex
      this.dataUserLocation = this.getUserLocation;
    },
  },
  computed: {

    getPrimaryCard() {
      return this.rootStore.primaryCard;
    },
    getUserLocation() {
      return this.rootStore.userLocation;
    },

    getIWTLoadWindow() {
      return this.rootStore.iwtLoadWindow;
    },

    getIsStateHoliday(){
      return this.rootStore.isStateHoliday;
    }, 
    getOfficeDL() {
      return this.rootStore.officeDL;
    },
    getOfficeKiosk(){
    return this.rootStore.officeKAllKiosks;
    },
    getOfficeLPA() {
      return this.rootStore.officeLPA;
    },
    getOfficeIRP() {
      return this.rootStore.officeIRP;
    },
    getOfficeLT() {
      return this.rootStore.officeLT;
    },
    getLocationsURLsearch() {
      return this.rootStore.locationsURLsearch;
    },
    getMapAPIkey() {
      return this.rootStore.mapAPIkey;
    },
    
    getOfficeToggleClosed() {
      return this.rootStore.toggleClosed;
    },
    getToggleDL() {
      return this.rootStore.toggleDL;
    },
    getToggleLPA() {
      return this.rootStore.toggleLPA;
    },
    getToggleMO() {
      return this.rootStore.toggleMO;
    },
    getToggleLT() {
      return this.rootStore.toggleLT;
    },
    getToggleIRP() {
      return this.rootStore.toggleIRP;
    },
    getOfficesNearby() {
      var _filteredNearby = [];
      var thisOff = this;

      this.rootStore.officesNearby.forEach(function (_off) {
        // Check for IRP in nested object
        var isIrp = false;

        _off.OfficeTypes.forEach(function (i) {
          if (i.Type === "irp") {
            isIrp = true;
          }
        });

        // Kiosk
        if (
          _off.OfficeTypes[0].Type === "kiosk" &&
          _off.Name !== ""
        ) {
          _filteredNearby.push(_off);
        }

        // Open Plate
        if (
          thisOff.getToggleLPA === true &&
          _off.OfficeTypes[0].Type === "plate" &&
          _off.Name !== ""
        ) {
          _filteredNearby.push(_off);
        }

        // L&T theft
        if (
          thisOff.getToggleLT === true &&
          _off.OfficeTypes[0].Type === "lt" &&
          _off.Name !== ""
        ) {
          _filteredNearby.push(_off);
        }

        // IRP Commercial
        if (
          thisOff.getToggleIRP === true &&
          isIrp === true &&
          _off.Name !== ""
        ) {
          _filteredNearby.push(_off);
        }

        // Open Driver License
        if (
          thisOff.getToggleDL === true &&
          _off.OfficeTypes[0].Type === "license" &&
          _off.IsMobile === false &&
          _off.Name !== ""
        ) {
          _filteredNearby.push(_off);
        }

        // Open mobile
        if (
          thisOff.getToggleMO === true &&
          _off.OfficeTypes[0].Type === "license" &&
          _off.IsMobile === true &&
          _off.Name !== ""
        ) {
          _filteredNearby.push(_off);
        }
      });
      // console.log(_filteredNearby)
      return _filteredNearby;
    },
    getMapAPIresponse() {
      return this.rootStore.mapAPIresponse;
    },
  },
};
</script>